import Mock from 'mockjs'

// 首页简单新闻列表数据
const simpleNewsList = [
  {
    id: 1,
    date: '2024-01-26',
    title: '亚科化学"2024年新年企业宣传片"发布'
  },
  {
    id: 2,
    date: '2024-01-20',
    title: '2024年亚科化学工作会议'
  },
  {
    id: 3,
    date: '2024-01-15',
    title: '2024年研发项目立项评审会'
  },
  {
    id: 4,
    date: '2024-01-10',
    title: '亚科化学荣获"创新成果奖"'
  },
  {
    id: 5,
    date: '2023-12',
    title: '亚科化学荣获"2023年度中国医药企业社会责任奖"'
  },
  {
    id: 6,
    date: '2023-11',
    title: '亚科化学成功举办2023年度技术创新研讨会暨项目路演活动'
  }
]

// 首页使用的简单新闻列表接口
export const getNewsList = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        code: 200,
        data: simpleNewsList,
        message: 'success'
      })
    }, 300)
  })
}

// 模拟新闻列表接口 (用于新闻页面)
Mock.mock(new RegExp('/api/news/list.*'), 'get', (config) => {
  // 解析查询参数
  const params = new URLSearchParams(config.url.split('?')[1])
  const page = parseInt(params.get('page')) || 1
  const pageSize = parseInt(params.get('pageSize')) || 10

  const list = Array(pageSize).fill(null).map((_, index) => ({
    id: (page - 1) * pageSize + index + 1,
    title: Mock.Random.ctitle(15, 30),
    description: Mock.Random.cparagraph(2, 4),
    date: Mock.Random.date('yyyy-MM-dd'),
    image: Mock.Random.image('600x400', Mock.Random.color(), '#FFF', 'News'),
    content: Mock.Random.cparagraph(10, 20),
    author: Mock.Random.cname(),
    views: Mock.Random.integer(100, 10000),
    tags: Array(Mock.Random.integer(1, 3)).fill(null).map(() => Mock.Random.ctitle(2, 4))
  }))

  return {
    code: 200,
    message: 'success',
    data: {
      list,
      total: 100,
      page,
      pageSize
    }
  }
})

// 模拟新闻详情接口
Mock.mock(new RegExp('/api/news/detail/\\d+'), 'get', (config) => {
  const id = parseInt(config.url.split('/').pop())
  
  return {
    code: 200,
    message: 'success',
    data: {
      id,
      title: Mock.Random.ctitle(15, 30),
      description: Mock.Random.cparagraph(2, 4),
      content: Mock.Random.cparagraph(20, 30),
      date: Mock.Random.date('yyyy-MM-dd'),
      image: Mock.Random.image('900x500', Mock.Random.color(), '#FFF', 'News'),
      author: Mock.Random.cname(),
      views: Mock.Random.integer(100, 10000),
      tags: Array(Mock.Random.integer(1, 3)).fill(null).map(() => Mock.Random.ctitle(2, 4))
    }
  }
})

export default {
  getNewsList,
  simpleNewsList
} 